import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextInputStringSchema } from '@common/validation/utils/getTextInputStringSchema';

export interface ITpoFlexGradingData {
    grading: string | null;
}

const tpoFlexGradingFinal: TypedSchema<ITpoFlexGradingData> = {
    grading: getTextInputStringSchema(),
};

const tpoFlexGradingDraft: TypedSchema<ITpoFlexGradingData> = addAllowNull(tpoFlexGradingFinal);

export const tpoFlexGradingDraftSchema = Koi.object(tpoFlexGradingDraft);
export const tpoFlexGradingFinalSchema = Koi.object(tpoFlexGradingFinal);
